module.exports = __webpack_public_path__ + "static/media/truck-check-outline.b9d0243f.svg";